/* eslint-disable */
import React from 'react';
import { Chip, Box, Select, MenuItem } from '@mui/material';
import { getGroupsWithColour } from '../../../../helpers/user';
import InputLabel from '../../../inputLabel';
import CloseIcon from '@mui/icons-material/Close';
import { ColorCodeGroups, sortByProperty } from '../../../../utils/general';
import { groupRoleMapping } from '../../../../pages/userProfile/components/userGroupsField/groupRoleMapper';
const LABEL_STYLES = { paddingTop: '10px' }

const GroupsTextField = ({ user, setUser }) => {
  const { groups: selectedGroups } = user;

  const handleDeleteGroup = (deletedGroupId) => {
    const updatedSelectedGroups = selectedGroups.filter(
      (selectedGroup) => selectedGroup?.value !== deletedGroupId
    );
    setUser({ ...user, groups: updatedSelectedGroups });
  };

  // const selectedGroupsWithColour = getGroupsWithColour(selectedGroups);

  const allSelectedGropus = {
    groups: selectedGroups.map(item => item.display)
  };
  const groupResult = groupRoleMapping(allSelectedGropus);
  const appGroups = Object.keys(groupResult)
  const groupMapColor = ColorCodeGroups(appGroups)
  const groupsSelected = sortByProperty(selectedGroups, 'display').map(item => {
    const name = item.display
    const key = name.includes("-") ? name.split("-")[0] : "Other"
    const cleanKey = key.trim();
    const color = groupMapColor[cleanKey] || "#ffffff";
    return {
      ...item,
      color,
    };
  });

  return (
    <Select
      size="small"
      sx={{ 
        width: '400px',
        padding: 'inherit !important',
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        }
       }}
      value={groupsSelected}
      multiple
      readOnly
      IconComponent={() => null}
      renderValue={(selected) => (
        <Box
          sx={{
            marginLeft:'-13px',
          }}
        >

          {selected.map((group) => (
            <Chip
              key={group?.value}
              label={group?.display}
              onDelete={() =>
                handleDeleteGroup(group?.value)}
              deleteIcon={
                <CloseIcon
                sx={{
                      color: 'black !important',
                      fontSize: '18px !important',
                    }}
                />
                }

              sx={{
                  display: 'flex',
                  alignItems: 'center', 
                  marginBottom: '6px',
                  width: 'fit-content',
                  border: '1px solid #ccc',
                  borderRadius: '999px',
                  fontWeight: '600',
                  backgroundColor: group?.color,
              }}
  
            />
          ))}
        </Box>
    )}
    >
      {selectedGroups.map((selectedGroup) => (
        <MenuItem key={selectedGroup?.value} value={selectedGroup?.value}>
          {selectedGroup?.display}
        </MenuItem>
    ))}
    </Select>
  );
};

export default GroupsTextField;
